const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M24.992 24.832q-0.672 0-1.184-0.512t-0.48-1.184 0.48-1.152 1.184-0.48q2.080 0 3.552-1.472t1.472-3.52-1.472-3.552-3.552-1.472q-0.704 0-1.344 0.224l-1.792 0.512-0.288-1.856q-0.448-2.4-2.272-3.968t-4.288-1.568q-2.752 0-4.736 1.952t-1.952 4.704q0 0.448 0.16 1.344l0.416 1.984h-2.368q-1.28 0-2.24 0.992t-0.96 2.336q0 1.408 0.96 2.368t2.4 0.992q0.672 0 1.152 0.48t0.48 1.152-0.48 1.184-1.152 0.512q-2.752 0-4.736-1.984t-1.952-4.704q0-2.336 1.408-4.096t3.584-2.336v-0.224q0-4.096 2.944-7.040t7.072-2.944q3.232 0 5.792 1.824t3.616 4.864q3.616-0.288 6.272 2.176t2.624 6.144q0 3.424-2.432 5.856t-5.888 2.464zM14.176 24.832l1.664-5.024 1.696 5.024q0.224 0.672-0.128 1.344t-0.992 0.896q-0.928 0.32-1.76-0.416t-0.48-1.824zM19.168 28.16l1.664-5.024 1.664 5.024q0.224 0.672-0.096 1.312t-0.992 0.928q-0.928 0.32-1.76-0.416t-0.48-1.824zM9.152 28.16l1.696-5.024 1.632 5.024q0.256 0.672-0.064 1.312t-1.024 0.928q-0.896 0.32-1.76-0.416t-0.48-1.824z"
});

const SvgRainyCloud = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-rainy-cloud",
    viewBox: "0 0 34 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRainyCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rainy-cloud.7c901df9.svg";
export { ForwardRef as ReactComponent };